import { IModuleState } from './types';
import { IActionFn } from '@/store/types';
import { $http } from '@/axios';
import store from '@/store';

// 查询文件列表
export const queryOssFiles: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setOssFiles', { ...state.ossFiles, loading: true });
    const res = await $http.post('/v1/baseinfo/brandstore/assets/filelist', payload);
    commit('setOssFiles', { data: res });
  } catch (e) {
    commit('setOssFiles', { data: [] });
  }
};

// 查询已发布的文件列表
export const queryPublishedFiles: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setOssFiles', { ...state.ossFiles, loading: true });
    const res: any[] = await $http.post('/v1/baseinfo/brandstore/assets/brandorgpublishlist', payload);
    // 将数据结构和文件列表保持统一
    const data = res.map((item) => ({
      id: item.id,
      isExist: item.isExist,
      pathName: `${item.filePath}/${item.fileName}`,
      isFolder: false,
      createdTime: item.createdTime,
      size: item.size,
    }));
    commit('setOssFiles', { data });
  } catch (e) {
    commit('setOssFiles', { data: [] });
  }
};

// 发布或下架 oss 文件
export const publishOssFile: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/baseinfo/brandstore/assets/shelf', payload);
    // store.commit('common/setToast', { visible: true, text: '文件发布成功' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 重命名 oss 文件
export const renameOssFile: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/baseinfo/brandstore/assets/rename', payload);

  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 删除 oss 文件
export const deleteOssFile: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/baseinfo/brandstore/assets/delete', payload);
    store.commit('common/setToast', { visible: true, text: '文件删除成功' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 检查文件是否已经被删除
export const checkIsDeleted: IActionFn<IModuleState> = async ({}, payload) => {
  try {
    // const isExist = await $http.post('/v1/baseinfo/brandstore/assets/existfile', payload);
    const isExist = await $http.post('/v1/check/baseinfo/brandstore/assetsexists', payload);
    if (!isExist) {
      store.commit('common/setToast', { visible: true, text: '文件不存在，请检查是否已经被删除' });
    }
    return !isExist;
  } catch (e) {
    return false;
  }
};

// 检查某个路径下，文件是否已经存在(接口同上面是一样的)
// 这是后续加的 action，避免修改上面的接口，以免影响已有功能
export const checkFileExisted: IActionFn<IModuleState> = async ({}, payload) => {
  try {
    const res = await $http.post('/v1/check/baseinfo/brandstore/assetsexists', payload);
    return !!res;
  } catch (e) {
    throw e;
  }
};

// 获取上传时的验证信息
export const getUploadPolicy: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setUploadPolicy', { ...state.uploadPolicy, loading: true });
    const res = await $http.post('/v1/baseinfo/brandstore/assets/upload', payload);
    commit('setUploadPolicy', { data: res });
    return res;
  } catch (e) {
    commit('setUploadPolicy', { data: null });
    throw e;
  }
};
